/* eslint-disable max-statements */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { c2cBenifitsV2, JOURNEY_STATUS } from "./constants";
import Skeleton from "./skeleton";
import priceFormatter from "../../../utils/helpers/price-formatter";
import PostInspectionMarketplaceListingStatus from "../post-inspection-marktplace-listing-status-v2";
import { LinkButton } from "@cars24/turbo-web/lib/link-button";
import PostInspectionMarketplaceWhyAdModal from "../post-inspection-marketplace-why-ad-modal";
import info from "./images/info.svg";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import CarInfoCard from "../../shared/car-info-card";
import { Text } from "@cars24/turbo-web/lib/text";
import { Button } from "@cars24/turbo-web/lib/button";
import styles from "./styles.css";
import rightArrowImage from "./images/right-arrow.png";
import { Divider } from "@cars24/turbo-web/lib/divider";

const PostInspectionMarketplaceCardV2 = ({
    listingData,
    handleCardClick,
    loading,
    handleCtaClick,
    ctaText: defaultCtaText,
    userId,
    selectedCity,
    leadId,
    inspectionResponse
}) => {
    const { tokens } = useTokens();

    const [showWhyAd, setShowWhyAd] = useState(false);

    const {
        variant,
        year,
        make,
        model,
        carImage,
        maskedRegistrationNumber,
        fuelType
    } = inspectionResponse || {};
    const {
        packageData: { free, listingPriceConfig = {} } = {},
        carListed,
        journeyStatus,
        id
    } = listingData || {};

    const ctaText = defaultCtaText || (id ? "Continue creating ad" : "Post an ad");

    const { COMPETITIVE_PRICE } = listingPriceConfig || {};
    const isSold =
    journeyStatus === JOURNEY_STATUS.SOLD ||
    journeyStatus === JOURNEY_STATUS.SOLD_WITHOUT_SPP;
    const { statusDetail } = listingData || {};
    const delisted = journeyStatus === JOURNEY_STATUS.DELISTED;

    // eslint-disable-next-line complexity
    const renderC2cCarCard = () => {
        if (loading) {
            return <Skeleton />;
        }

        return (
            <div styleName="outerCard"
                onClick={handleCardClick}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "10px 0",
                        color: "#216DFE"
                    }}
                >
                    <Text
                        size="200"
                        fontWeight="semibold"
                        color={tokens.text_brand_text_accent}
                    >
            Increase your chances of a better deal ⚡️
                    </Text>
                </div>
                <div styleName="styles.card">
                    <div styleName="styles.cardContent">
                        {carListed ? (
                            <>
                                {statusDetail && (
                                    <PostInspectionMarketplaceListingStatus {...statusDetail} />
                                )}
                                {journeyStatus === JOURNEY_STATUS.DELISTED && (
                                    <div styleName="styles.delist">
                                        <img src={info} height={16} width={16} alt="info" />
                                        <BodyText
                                            level={3}
                                            color={tokens.text_default_text_secondary}
                                        >
                                            You have removed this car advertisement
                                        </BodyText>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <div styleName="styles.heading">
                                    <div styleName="styles.cardHeader">
                                        {/* <RadioButton selected={selected} /> */}
                                        <Text size="450" fontWeight="semibold">
                                            Post your car ad
                                        </Text>
                                    </div>
                                </div>
                                <div>
                                    <Text size="200" color={tokens.text_default_text_secondary}>
                                        List your car on CARS24 and reach 6 lakh+ buyers across
                                        India.
                                    </Text>
                                </div>
                                <div styleName="styles.list">
                                    {(c2cBenifitsV2 || []).map((_info, index) => (
                                        <div styleName="styles.listItem" key={index}>
                                            <img
                                                src={_info.icon}
                                                alt={_info.label}
                                                style={{ width: "24px", height: "24px" }}
                                            />
                                            <Text size="200" color={tokens.text_default_text_primary}>
                                                {_info.label}
                                            </Text>
                                        </div>
                                    ))}
                                </div>
                                <Divider variant="secondary" />
                                <div
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                >
                                    <div styleName={""}>
                                        <Text size="200" color={tokens.text_default_text_secondary}>
                                            Ad listing fee starting
                                        </Text>
                                        <Text level="200" fontWeight="semibold">
                                            {free
                                                ? "FREE"
                                                : `₹${priceFormatter(
                                                    COMPETITIVE_PRICE || 0,
                                                    true,
                                                    "IN"
                                                )}`}
                                        </Text>
                                    </div>

                                    <div styleName="styles.viewAdCta">
                                        <LinkButton
                                            label="Why advertise"
                                            onClick={async () => {
                                                await yieldToMain();
                                                setShowWhyAd(true);
                                                sendCustomGaEvents({
                                                    event: "c2c_event",
                                                    device_type: "M-WEB",
                                                    user_id: userId,
                                                    page_title: "Post Inspection Marketplace",
                                                    eventName: "mp_c2c_c2b_whycars24_viewed",
                                                    eventLabel: "c2b_c2c_entrypoint_viewed",
                                                    eventAction: "page_view",
                                                    page_url: window.location.href,
                                                    logged_in: true,
                                                    cityId: selectedCity.id,
                                                    city_name: selectedCity.name,
                                                    appointment_id: leadId,
                                                    eventCategory: "c2c_c2b_sell_options"
                                                });
                                            }}
                                            variant="black"
                                            preventDefaultBehaviour={true}
                                            underLine={false}
                                            suffixIcon={
                                                <img
                                                    src={rightArrowImage}
                                                    alt="right arrow"
                                                    style={{ width: "16px", height: "16px" }}
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        {!delisted && (
                            <Button
                                label={ctaText}
                                onClick={handleCtaClick}
                                variant="secondary"
                                size="small"
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    };

    if (isSold) {
        return (
            <>
                <CarInfoCard
                    car={{
                        listingImage: {
                            bgRemovedUri: carImage,
                            key: variant
                        },
                        regNumber: maskedRegistrationNumber,
                        year,
                        make,
                        model,
                        fuelType,
                        variant
                    }}
                    badge={statusDetail && statusDetail.badge}
                />
            </>
        );
    }

    return (
        <>
            {renderC2cCarCard()}
            <div styleName="styles.modalCotainer">
                <PostInspectionMarketplaceWhyAdModal
                    ctaText={ctaText}
                    onClose={() => setShowWhyAd(false)}
                    isOpen={showWhyAd}
                    onClick={() => handleCtaClick()}
                />
            </div>
        </>
    );
};

PostInspectionMarketplaceCardV2.propTypes = {
    listingData: PropTypes.object,
    handleCardClick: PropTypes.func,
    selected: PropTypes.bool,
    loading: PropTypes.bool,
    handleCtaClick: PropTypes.func,
    ctaText: PropTypes.string,
    userId: PropTypes.string,
    selectedCity: PropTypes.object,
    leadId: PropTypes.string,
    inspectionResponse: PropTypes.object
};

export default PostInspectionMarketplaceCardV2;
